import { ReactNode, createContext, useContext } from 'react';
import { useBoolean } from '@shared/util/hooks';

interface ComponentFocusContextValue {
  isComponentFocused: boolean;
  setComponentFocused: VoidFunction;
  setComponentBlurred: VoidFunction;
}
const defaultValue: ComponentFocusContextValue = {
  isComponentFocused: false,
  setComponentFocused: () => {},
  setComponentBlurred: () => {},
};

export const ComponentFocusContext = createContext<ComponentFocusContextValue>(defaultValue);

interface Props {
  children: ReactNode;
}

export function ComponentFocusProvider({ children }: Props) {
  const [isComponentFocused, setComponentFocused, setComponentBlurred] = useBoolean(false);
  return (
    <ComponentFocusContext.Provider
      value={{
        isComponentFocused,
        setComponentFocused,
        setComponentBlurred,
      }}
    >
      {children}
    </ComponentFocusContext.Provider>
  );
}

export function useComponentFocus() {
  return useContext(ComponentFocusContext);
}
